import { FC } from "react";

import MosaicItem, { BaseMosaicItem } from "@/common/components/liveUnitMosaic/Mosaic/MosaicItem/MosaicItem";

import useStyles from "./Mosaic.styles";


//General Mosaic component which takes in a list of data (should include cameraId) and the component which renders this data.
interface MosaicProps<T extends BaseMosaicItem> {
    data: T[];

    /**
     * Additional props that are passed to the tile
     */
    tileProps?: {[key: string]: any};
    TileComponent: FC<any>;
    onClose?: (id: number | string) => void
}

export const Mosaic = <T extends BaseMosaicItem>({ data, tileProps, TileComponent, onClose }: MosaicProps<T>) => {
    const styles = useStyles();

    return (
        <div className={styles.mosaic}>
            {data.map((datum: T) => (
                <MosaicItem
                    key={datum.cameraId}
                    nTiles={data.length}
                >
                    <TileComponent
                        datum={datum}
                        onClose={onClose ? () => onClose(datum.cameraId) : undefined}
                        {...tileProps}
                    />
                </MosaicItem>
            ))}
        </div>
    );
};
